import * as Sentry from "@sentry/vue";

export default function sentryInit(app, router) {
  Sentry.init({
    app,
    dsn: document.body.dataset.sentryDsn,
    environment: document.body.dataset.sentryEnvironment,
    release: document.body.dataset.sentryRelease,

    integrations: [
      Sentry.browserTracingIntegration({
        router,
        routeLabel: "path",
        tracingOrigins: [window.location.host, /^\//],
      }),
    ],

    tracesSampleRate: 1.0, // 0.2,
  });
}
